import {useState, useEffect, forwardRef, useCallback, useContext} from "react";
import { Date } from "../style/LogStyles";
import Post from "./Post";
import {initialPostData, LogContext} from "../../../../context/LogContext";

const Grouped = forwardRef(({ posts, date, getMap}, ref) => {
    const [requestedScrollPostId, setRequestedScrollPostId] = useState(undefined);
    const {setPostData, setSelectedImageData} = useContext(LogContext);
    const scrollToPost = useCallback((postId) => {
        setPostData(initialPostData);
        setSelectedImageData(undefined);
        setRequestedScrollPostId(postId);
    }, [setPostData, setSelectedImageData]);


    useEffect(() => {
        if (requestedScrollPostId && requestedScrollPostId.length > 0) {
            const map = getMap();
            const node = map.get(requestedScrollPostId);
            node.scrollIntoView(true);
            setRequestedScrollPostId(undefined)
        }
    }, [getMap, requestedScrollPostId]);
    return (
    <div
      style={{ display: "flex", flexDirection: "column", position: "relative" }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          position: "sticky",
          top: 0,
          zIndex: 1, 
          padding: "8px 0",
        }}
      >
        <Date>{date}</Date>
      </div>
      {/* Keyed by id: older pages are prepended, so index keys would re-use the nodes on screen. */}
      {posts.map((post) => (
        <Post scrollToPost={scrollToPost} ref={(node) => {
            const map = getMap();
            if (node) {
                map.set(post.PostId, node);
            } else {
                map.delete(post.PostId);
            }
        }} key={post.PostId} post={post} />
      ))}
    </div>
  );
});

export default Grouped;
